module.exports = __webpack_public_path__ + "static/media/latymerCourt1.554b6c4f.jpg";